import { getCurrentInstance, inject, provide } from 'vue';
import { injectionKey } from './injectionKey.js';
/** Retrieves the nearest IoC container from the Vue component hierarchy. */
export function useContainer() {
    const instance = getCurrentInstance();
    let container = instance?.provides?.[injectionKey];
    if (container) {
        return container;
    }
    container = inject(injectionKey);
    if (!container) {
        throw new Error('Container not registered. Register IocPlugin first');
    }
    return container;
}
/** Creates and provides a child IoC container scoped to the current component. */
export function useChildContainer(scope) {
    const container = useContainer();
    const child = container.createChild(scope);
    provide(injectionKey, child);
    return child;
}
//# sourceMappingURL=useContainer.js.map